import React from 'react';
import { Box, Typography } from '@mui/material';
import { SAGE } from '../../theme';

const F = "'Outfit', sans-serif";

/**
 * SectionHeader — chrome above each dashboard section.
 *
 * Hover-revealed drag handle is intentionally visual-only for now (the
 * handoff doc earmarks it for Layer 2 customization). Wire up later.
 */
const SectionHeader = ({ label, count, sub, rightSlot }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-end',
      gap: 1.5,
      mb: 1.5,
      pl: 0.5,
      '& .drag-handle': { opacity: 0, transition: 'opacity 0.15s' },
      '&:hover .drag-handle': { opacity: 1 },
    }}
  >
    <Box className="drag-handle" sx={{ color: SAGE[300], fontSize: 14, cursor: 'grab', mb: 0.25 }}>
      ⋮⋮
    </Box>
    <Box>
      <Typography
        sx={{
          fontFamily: F,
          fontSize: '0.95rem',
          fontWeight: 600,
          color: SAGE[800],
          letterSpacing: 0.2,
        }}
      >
        {label}
        {count != null && (
          <Box
            component="span"
            sx={{ ml: 1, fontSize: '0.7rem', color: SAGE[400], fontWeight: 500 }}
          >
            {count}
          </Box>
        )}
      </Typography>
      {sub && (
        <Typography
          sx={{
            fontFamily: F,
            fontSize: '0.72rem',
            fontStyle: 'italic',
            color: SAGE[500],
            mt: 0.25,
          }}
        >
          {sub}
        </Typography>
      )}
    </Box>
    <Box sx={{ flex: 1 }} />
    {rightSlot}
  </Box>
);

export default SectionHeader;
